import React, {useEffect, useState, useCallback} from "react";
import "./License.css";
import Grid from "@material-ui/core/Grid";
import LicenseService from "../../../../services/LicenseService/LicenseService";
import {useTranslation} from "react-i18next";
import {getExtension, convertToDateFormat} from "../../../../helpers/helper";
import {useSetRecoilState, useRecoilValue} from 'recoil';
import {alertState, personalizationState} from '../../../../recoil-store/recoil-state';
import Chip from "@material-ui/core/Chip";

function License() {
    const [data, setData] = useState({});
    const {t} = useTranslation();
    const [license, setLicense] = useState();
    const setAlert = useSetRecoilState(alertState);
    const personalization = useRecoilValue(personalizationState);

    const fetchData = async () => {
        const response = await LicenseService.getLicenseDetail();
        if (response && response.status) {
            setData(response.data);
        } else {
            setAlert(alert => ({...alert, show: true, message: t("GENERAL.NETWORK-ERROR"), severity: 'error'}));
        }
    };

    useEffect(() => {
        fetchData().then(r => r);
    }, []);

    function addLicense() {
        document.getElementById("license-file-input").click();
    }

    function handleChange(e) {
        if (e.target.files[0]?.name) {
            let extension = getExtension(e.target.files[0]?.name);
            if (extension === "xml") {
                setLicense(e.target.files[0]);
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LICENSE.LICENSE-XML-FORMAT"),
                    severity: 'error'
                }));
            }
        }
    }

    const handleSubmit = async () => {
        const response = await LicenseService.addNewLicense(license);
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.LICENSE.' + response.message),
                severity: response.status ? 'success' : 'error'
            }));
            if (response.status) {
                await fetchData();
                window.location.reload();
            }
        } else {
            setAlert(alert => ({...alert, show: true, message: t("GENERAL.NETWORK-ERROR"), severity: 'error'}));
        }
    };
    return (
        <div className="slicense">
            <div>{t("CONTENT.LICENSE.LICENSE")}</div>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4} lg={3}>
                    <div className="license-header-text">
                        {t("CONTENT.LICENSE.COMPANY-NAME")}
                    </div>
                    <div className="license-text">{data?.company_name}</div>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <div className="license-header-text">
                        {t("CONTENT.ABOUT.LICENSE-NUMBER")}
                    </div>
                    <div className="license-text">{data?.key}</div>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <div className="license-header-text">
                        {t("CONTENT.LICENSE.NUMBER-RPA")}
                    </div>
                    <div className="license-text">{data?.no_of_rpa_bots}</div>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <div className="license-header-text">{t("CONTENT.ABOUT.E-MAIL")}</div>
                    <div className="license-text">{data?.email}</div>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <div className="license-header-text">
                        {t("CONTENT.ABOUT.LICENSE-TYPE")}
                    </div>
                    <div className="license-text">{data?.type}</div>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <div className="license-header-text">
                        {t("CONTENT.LICENSE.ADD-ONS")}
                    </div>
                    <div className="license-text">
                        {data?.add_ons && data?.add_ons.map((item, index) => <Chip key={index} size="small" label={item}
                                                                                   color="primary"
                                                                                   style={{marginRight: 5}}/>)}
                    </div>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <div className="license-header-text">
                        {t("CONTENT.LICENSE.ACTION-LIMIT")}
                    </div>
                    <div className="license-text">
                        {data?.action_limit}
                    </div>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <div className="license-header-text">
                        {t("CONTENT.LICENSE.EXPIRE-DATE")}
                    </div>
                    <div className="license-text">
                        {data?.expire_date &&
                        convertToDateFormat(data.expire_date, personalization.date_format, false)
                        }
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div
                        className="mail-server-bottom-line"
                        style={{marginBottom: 31, marginTop: 25}}
                    />
                    <div className="mail-server-bottom-section">
                        <input type="file" name="file" accept=".xml" hidden id="license-file-input"
                               onChange={handleChange}/>
                        <div className="mail-server-button-save" onClick={addLicense}>
                            {t("CONTENT.LICENSE.ADD-LICENSE")}
                        </div>

                        <div className="mail-server-button-cancel" onClick={handleSubmit}>
                            {t("CONTENT.LICENSE.SUBMIT")}
                        </div>
                    </div>
                    <small className="mail-server-small-text">{license && license.name}</small>
                </Grid>
            </Grid>
        </div>
    );
}

export default License;
